<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        
      </div>
      <!-- Card stats -->
    <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card title="Processadas"
                      type="gradient-green"
                      sub-title="140"
                      icon="ni ni-check-bold">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
              <span class="text-nowrap">Na semana</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="Pendentes"
                      type="gradient-blue"
                      sub-title="12"
                      icon="ni ni ni-notification-70">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 1.18%</span>
              <span class="text-nowrap">Na semana</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="Divergentes"
                      type="gradient-red"
                      sub-title="14"
                      icon="ni ni-fat-remove">

            <template slot="footer">
              <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 3%</span>
              <span class="text-nowrap">Na semana</span>
            </template>
          </stats-card>

        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="Aguardando"
                      type="gradient-info"
                      sub-title="2,65%"
                      icon="ni ni-settings">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 1.8%</span>
              <span class="text-nowrap">Na Semana</span>
            </template>
          </stats-card>
        </div>
      </div>  
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
     
      <!--Tables-->
      <div class="row">
        <div class="col-xl-12">
          <ultimasFaturas></ultimasFaturas>
        </div>
        
      </div>
      <!--End tables-->
    </div>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";

// Components
import BaseProgress from "@/components/BaseProgress";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";

// Lists
import ActivityFeed from "./ActivityFeed";
import TaskList from "./TaskList";
import UserList from "./UserList";
import ProgressTrackList from "./ProgressTrackList";

// Tables
import LightTable from "./LightTable";
import SocialTrafficTable from "./SocialTrafficTable";
import ultimasFaturas from "./ultimasFaturas";

export default {
  components: {
    ActivityFeed,
    LineChart,
    BarChart,
    BaseProgress,
    RouteBreadCrumb,
    StatsCard,
    TaskList,
    SocialTrafficTable,
    LightTable,
    UserList,
    ProgressTrackList,
    ultimasFaturas
  },
  data() {
    return {
      bigLineChart: {
        allData: [
          [0, 20, 10, 30, 15, 40, 20, 60, 90],
          [0, 20, 5, 25, 10, 30, 15, 40, 40]
        ],
        activeIndex: 0,
        chartData: {
          datasets: [
            {
              label: "Performance",
              data: [0, 20, 10, 30, 15, 40, 20, 60, 90]
            }
          ],
          labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        },
        extraOptions: chartConfigs.blueChartOptions
      },
      redBarChart: {
        chartData: {
          labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          datasets: [
            {
              label: "Sales",
              data: [25, 20, 30, 22, 17, 29],
              color:"blue"
            },
            {
              label: "Sales",
              data: [25, 20, 30, 22, 17, 29]
            }
          ]
        }
      }
    };
  },
  methods: {
    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            label: "Performance",
            data: this.bigLineChart.allData[index]
          }
        ],
        labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      };
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    }
  },
  mounted() {
    this.initBigChart(0);
  }
};
</script>
<style></style>
